import { Button, Grid } from "@mui/material";
import CardHESP from "../../components/CardHESP/CardHESP";
import SectionTitleWithAction from "../../components/SectionTitle/SectionTitleWithAction";
import { Add, InfoOutlined } from "@mui/icons-material";
import { navigate, RouteComponentProps } from "@reach/router";
import { OrderDirectionType } from "../../__generated__/globalTypes";
import * as React from "react";
import moment from "moment";
import ReportFilters from "../../components/Reports/ReportFilters";
import ReportOverviewList from "../../components/Reports/ReportsOverviewList";
import styled from "styled-components";

interface Props extends RouteComponentProps {
    organizationId?: string;
}

export interface ReportFilterValues {
    startDate: string;
    endDate: string;
    search: string;
    sortBy: string;
    sortDirection: OrderDirectionType;
}

const Info = styled.div`
    background-color: ${(props) => props.theme.lighterBlue};
    border-radius: 8px;
    padding: 10px;
    font-size: 13px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
`;

export default function ReportingOverviewWithFilters({ organizationId }: Props): JSX.Element {
    const [filters, setFilters] = React.useState<ReportFilterValues>({
        startDate: moment("2024-08-01").startOf("day").toISOString(),
        endDate: moment().endOf("day").toISOString(),
        search: "",
        sortBy: "start",
        sortDirection: OrderDirectionType.desc,
    });

    return (
        <Grid container spacing={{ xs: 5, md: 6 }} justifyContent="center" alignItems={"center"} alignContent="center">
            <Grid item xs={12}>
                <SectionTitleWithAction
                    title="Reports"
                    action={
                        <Button
                            variant="contained"
                            startIcon={<Add />}
                            onClick={() => navigate(`/app/${organizationId}/reporting/add`)}
                        >
                            Add
                        </Button>
                    }
                />
                <CardHESP>
                    <ReportFilters
                        filterValues={filters}
                        onApplyFilters={(newFilter: ReportFilterValues) => setFilters(newFilter)}
                        sortItems={[
                            { id: "name", text: "Name" },
                            { id: "id", text: "ID" },
                            { id: "client_id", text: "Client ID" },
                            { id: "start", text: "Start Date" },
                            { id: "end", text: "End Date" },
                        ]}
                    />
                    <Info>
                        <InfoOutlined fontSize="small" /> Reports will be generated 20 minutes after end time
                    </Info>
                    <ReportOverviewList organizationId={organizationId!} filters={filters} />
                </CardHESP>
            </Grid>
        </Grid>
    );
}
